/**
 *  Point of contact for widget components
 *
 *  ie: import { Example } from 'components/widgets';
 *
 */
import Accordion from 'website/widgets/dynamic/Accordion/legacy';
import BlogCategories from 'website/widgets/dynamic/BlogCategories/legacy';
import BlogHome from 'website/widgets/dynamic/BlogHome/legacy';
import BlogPost from 'website/widgets/static/BlogPost/legacy';
import Breadcrumbs from 'website/widgets/static/Breadcrumbs/legacy';
import Button from 'website/widgets/static/Button/legacy';
import Carousel from 'website/widgets/dynamic/Carousel/legacy';
import ClassicUnitCategories from 'website/widgets/dynamic/ClassicUnitCategories/legacy';
import ContactForm from 'website/widgets/dynamic/ContactForm/legacy';
import ContentBox from 'website/widgets/static/ContentBox/legacy';
import Coupon from 'website/widgets/dynamic/Coupon/legacy';
import DirectionsText from 'website/widgets/static/DirectionsText/legacy';
import EmbedContent from 'website/widgets/dynamic/EmbedContent/legacy';
import FacilityAmenities from 'website/widgets/dynamic/FacilityAmenities/legacy';
import FacilityGroupWidget from 'website/widgets/dynamic/FacilityGroup/legacy';
import FacilityImageSlideShow from 'website/widgets/dynamic/FacilityImageSlideShow/legacy';
import FacilityInformation from 'website/widgets/static/FacilityInformation/legacy';
import FacilityReviews from 'website/widgets/dynamic/FacilityReviews/legacy';
import FacilitySearchBar from 'website/widgets/dynamic/FacilitySearchBar/legacy';
import FacilityUnitsOne from 'website/widgets/dynamic/FacilityUnitsOne/legacy';
import FacilityUnitsTwo from 'website/widgets/dynamic/FacilityUnitsTwo/legacy';
import RentalApp from 'website/widgets/dynamic/RentalApp/legacy';
import FacilityUnitsThree from 'website/widgets/dynamic/FacilityUnitsThree/legacy';
import GoogleTranslate from 'website/widgets/dynamic/GoogleTranslate/legacy';
import HeaderLogo from 'website/widgets/static/HeaderLogo/legacy';
import HeaderText from 'website/widgets/static/HeaderText/legacy';
import Hours from 'website/widgets/static/Hours/legacy';
import Image from 'website/widgets/dynamic/Image/legacy';
import ImageGrid from 'website/widgets/dynamic/ImageGrid/legacy';
import MapboxMapAllFacilities from 'website/widgets/dynamic/MapboxMapAllFacilities/legacy';
import MapboxMapOneFacility from 'website/widgets/dynamic/MapboxMapOneFacility/legacy';
import Navigation from 'website/widgets/dynamic/Navigation/legacy';
import NavigationV2 from 'website/widgets/dynamic/NavigationV2/legacy';
// import NearbyLocations from 'website/widgets/dynamic/NearbyLocations/legacy';
import OMIWidget from 'website/widgets/dynamic/OMIWidget/legacy';
import LocationsNearYou from 'website/widgets/dynamic/LocationsNearYou/legacy';
import PayOnline from 'website/widgets/dynamic/PayOnline/legacy';
import Placeholder from 'website/widgets/static/Placeholder/legacy';
import PopUp from 'website/widgets/dynamic/PopUp/legacy';
import PromotionBanner from 'website/widgets/dynamic/PromotionBanner/legacy';
import ReviewButton from 'website/widgets/dynamic/ReviewButton/legacy';
import ReviewStars from 'website/widgets/dynamic/ReviewStars/legacy';
import UnitSizes from 'website/widgets/dynamic/UnitSizes/legacy';
import Reviews from 'website/widgets/dynamic/Reviews/legacy';
import SocialMediaIcons from 'website/widgets/static/SocialMediaIcons/legacy';
import StorageCalculator from 'website/widgets/dynamic/StorageCalculator/legacy';
import StockIcons from 'website/widgets/static/StockIcons/legacy';
import Video from 'website/widgets/dynamic/Video/legacy';
import NearbyLocations from '../../../../website/widgets/dynamic/NearbyLocations/legacy';
import * as rcWidgets from './rentalCenterWidgets';
import EmailContactForm from 'website/widgets/dynamic/EmailContactForm/legacy';
// import OMIWidget from '../OMIWidget/OMIWidget';

const widgets = {
  Accordion,
  BlogHome,
  BlogPost,
  BlogCategories,
  Breadcrumbs,
  Button,
  Carousel,
  ContactForm,
  ContentBox,
  Coupon,
  DirectionsText,
  EmbedContent,
  FacilityAmenities,
  FacilityGroupWidget,
  FacilityImageSlideShow,
  FacilityInformation,
  FacilityReviews,
  FacilitySearchBar,
  FacilityUnitsOne,
  FacilityUnitsTwo,
  RentalApp,
  FacilityUnitsThree,
  GoogleTranslate,
  HeaderLogo,
  HeaderText,
  Hours,
  Image,
  ImageGrid,
  MapboxMapAllFacilities,
  MapboxMapOneFacility,
  Navigation,
  NavigationV2,
  NearbyLocations,
  OMIWidget,
  LocationsNearYou,
  PayOnline,
  PopUp,
  PromotionBanner,
  ReviewButton,
  Reviews,
  SocialMediaIcons,
  ReviewStars,
  StockIcons,
  StorageCalculator,
  UnitSizes,
  ClassicUnitCategories,
  Video,
  EmailContactForm,
};

const allWidgets = { ...widgets, ...rcWidgets };

export { widgets, rcWidgets, allWidgets, PayOnline, HeaderLogo, Placeholder };
